// extracted by mini-css-extract-plugin
export default {"container":"credits_container__3jtuK","title":"credits_title__29es-","credit":"credits_credit__3CAqJ","credits":"credits_credits__3mB2i"};